import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateDataSetConfigurationRequest, ExportDataSetConfigurationResponse, ExportDataSetFromSelectionRequest, ExportDataSetsModel, GetDataSetConfigurationResponse, GetDataSetConfigurationsRequest, GetDataSetConfigurationsResponse, ImportDataSetConfigurationRequest, ValidateExportDataSetsResponse, ValidateImportDataSetConfigurationCommandResponse } from '../../models/data-set-configuration-models';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataSetConfigurationService {
  private api = `${environment.baseV5ApiUri}/DataSetConfiguration`;
  constructor(private http: HttpClient) { }

  getFiltered(request: GetDataSetConfigurationsRequest): Observable<GetDataSetConfigurationsResponse> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }

    return this.http.get<GetDataSetConfigurationsResponse>(`${this.api}`, { params });
  }

  create(request: CreateDataSetConfigurationRequest): Observable<any> {
    return this.http.post<GetDataSetConfigurationsResponse>(`${this.api}`, request);
  }

  getById(id: string): Observable<GetDataSetConfigurationResponse> {
    return this.http.get<GetDataSetConfigurationResponse>(`${this.api}/${id}`);
  }

  update(id: string, request: CreateDataSetConfigurationRequest): Observable<void> {
    return this.http.put<void>(`${this.api}/${id}`, request);
  }

  delete(id: string)
  {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  export(ids: string[]): Observable<ExportDataSetConfigurationResponse> {
    return this.http.post<ExportDataSetConfigurationResponse>(`${this.api}/export`, ids);
  }

  exportWithDependencies(ids: string[]): Observable<ExportDataSetsModel> {
    return this.http.post<ExportDataSetsModel>(`${this.api}/export-with-dependencies`, ids);
  }

  validateExport(ids: string[]): Observable<ValidateExportDataSetsResponse> {
    return this.http.post<ValidateExportDataSetsResponse>(`${this.api}/validate-export`, ids);
  }

  exportFromSelection(request: ExportDataSetFromSelectionRequest): Observable<ExportDataSetsModel> {
    return this.http.post<ExportDataSetsModel>(`${this.api}/export-from-selection`, request);
  }

  validateImport(file: File): Observable<ValidateImportDataSetConfigurationCommandResponse> {
    const formData = new FormData();
    formData.append('json', file);

    return this.http.post<ValidateImportDataSetConfigurationCommandResponse>(`${this.api}/validate-import`, formData);
  }

  importEntities(request: ImportDataSetConfigurationRequest): Observable<string[]> {
    return this.http.post<string[]>(`${this.api}/import`, request);
  }

  bulkDelete(ids: string[]): Observable<void> {
    return this.http.delete<void>(`${this.api}/bulk-delete`, { body: ids });
  }
}
